module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/new_photo_07@2x-ef9e6aa219ff5951c0e123de5ab631d0.jpg";